import { useEffect, useState } from "react";

const useOrder = () => {
  const [orderList, setOrderList] = useState();
  useEffect(() => {
    fetch("https://clariss-backend-one.vercel.app/order")
      .then((res) => res.json())
      .then((data) => setOrderList(data));
  }, []);

  return [orderList, setOrderList];
};
export default useOrder;
